export default __webpack_public_path__ + "static/media/bbb_icon.d88d7a9b.svg";